import appInsights from './src/utils/appInsights';

export const onRouteUpdate = ({ location }) => {
  appInsights.trackPageView({ uri: location.pathname });
};